<template>
    <div>
        <!-- bool -->
        <el-switch v-if="p.tipo === 'bool'"
                   :value="paraBool(valor)"
                   :disabled="disabled"
                   @change="$emit('save', $event)"
                   active-text="Habilitado" inactive-text="Desabilitado"></el-switch>

        <!-- int -->
        <el-input-number v-else-if="p.tipo === 'int'"
                         v-model="localInt"
                         :disabled="disabled"
                         @change="$emit('save', localInt)"
                         :min="0" :step="1" style="width: 200px;"></el-input-number>

        <!-- json -->
        <div v-else-if="p.tipo === 'json'">
            <el-input type="textarea" :rows="6"
                      v-model="jsonTemp"
                      :disabled="disabled"
                      placeholder='{"chave":"valor"}'></el-input>
            <el-button type="primary" size="mini" plain class="u-mt-5" :disabled="disabled" @click="salvarJson">
                <i class="el-icon-check"></i> Salvar JSON
            </el-button>
            <span v-if="erroJson" style="color: #f56c6c; font-size: 12px; margin-left: 10px;">{{ erroJson }}</span>
        </div>

        <!-- string -->
        <el-input v-else
                  v-model="localStr"
                  :disabled="disabled"
                  @change="$emit('save', localStr)"
                  style="max-width: 600px;"></el-input>
    </div>
</template>

<script>
// Controle de edição de um parâmetro conforme seu tipo (bool/int/json/string).
// Mantém estado local editável (v-model) sincronizado com a prop `valor`,
// e emite 'save' com o novo valor; o pai é quem persiste.
export default {
    name: 'ParamControl',
    props: {
        p: { type: Object, required: true },
        valor: { default: null },
        disabled: { type: Boolean, default: false }
    },
    data () {
        return {
            localInt: 0,
            localStr: '',
            jsonTemp: '',
            erroJson: ''
        }
    },
    watch: {
        valor: { immediate: true, handler (v) { this.sincronizar(v) } }
    },
    methods: {
        sincronizar (v) {
            this.localInt = this.paraInt(v)
            this.localStr = (v === null || v === undefined) ? '' : String(v)
            this.jsonTemp = this.paraJson(v)
            this.erroJson = ''
        },
        paraBool (v) { return v === '1' || v === 'true' || v === true || v === 1 },
        paraInt (v) { const n = parseInt(v); return isNaN(n) ? 0 : n },
        paraJson (v) {
            if (!v) return ''
            try {
                const parsed = typeof v === 'string' ? JSON.parse(v) : v
                return JSON.stringify(parsed, null, 2)
            } catch (e) { return String(v) }
        },
        salvarJson () {
            try {
                const obj = JSON.parse(this.jsonTemp)
                this.erroJson = ''
                this.$emit('save', obj)
            } catch (e) {
                this.erroJson = 'JSON inválido — verifique a sintaxe.'
            }
        }
    }
}
</script>
